module.exports = __webpack_public_path__ + "static/media/statusApproved.0643c445.svg";